import { useMutation } from '@tanstack/react-query'
import { postAcceptEstimate } from 'services/PaymentsService'

export const usePostAcceptEstimateMutation = () => {
  return useMutation({ mutationFn: postAcceptEstimate })
}
